import React from "react";
import { Pie } from "@ant-design/plots";
import { encode } from "punycode";

type StatusPieProps = {
  data: { statusName: string; percentage: number }[];
  width?: number;
  height?: number;
};



const StatusPie: React.FC<StatusPieProps> = ({ data, width , height }) => {
  const config = {
    data: data,
    angleField: "percentage",
    colorField: "statusName",
    radius: 1,
    encode: {'color':'statusName'},
    scale:{'color':{palette:['#9ac0dc', '#5267b6', '#7a99cb', '#2f3aa4', '#00008b', '#13235c']}},
    width:width,
    height:height,
    innerRadius: 0.6,
    legend: {
      custom: false,
      color: {
        title: false,
        position: "right",
        rowPadding: 5,
        
      },
    },
    interaction : { 
      legendFilter : false , 
    },

    tooltip: { style: { showMarkers: false}, title: "statusName", formatter: null, },
    
  };

  return (<Pie {...config} />  );
};

export default StatusPie;
